export default {
    type: 'Вид работ',
    closeViolation: 'Закрыть предписание',
    back: 'Вернуться к форме',
    causes: 'Просмотр причины отклонения',
};
